import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { environment } from 'src/environments/environment';
import { Response } from "../models/util/responseUtil.model";

@Injectable({
  providedIn: "root",
})
export class ListsCovinocService {
  URL: string;

  constructor(private http: HttpClient) {
    this.URL = environment.urlApiNit + "/covi-utils";
  }

  findAllLists(): Observable<Response<ListsCovinocService>> {
    return this.http.get<Response<ListsCovinocService>>(this.URL + "/lists");
  }
}
